type PermissionTreeNode = {
  key?: string | number | null;
  children?: PermissionTreeNode[];
  permissions?: PermissionTreeNode[];
};

type AntdCheckedKeys =
  | Array<string | number>
  | {
      checked?: Array<string | number>;
      halfChecked?: Array<string | number>;
    };

const normalizeCheckedKeys = (checkedKeys: AntdCheckedKeys) => {
  const keys = Array.isArray(checkedKeys)
    ? checkedKeys
    : Array.isArray(checkedKeys?.checked)
      ? checkedKeys.checked
      : [];

  return keys
    .filter((key) => key !== undefined && key !== null)
    .map((key) => String(key));
};

const collectLeafPermissionKeys = (
  nodes: PermissionTreeNode[] = [],
  leafKeys = new Set<string>(),
) => {
  nodes.forEach((node) => {
    const children = Array.isArray(node.children)
      ? node.children
      : Array.isArray(node.permissions)
        ? node.permissions
        : [];

    if (children.length > 0) {
      collectLeafPermissionKeys(children, leafKeys);
      return;
    }

    if (node.key !== undefined && node.key !== null) {
      leafKeys.add(String(node.key));
    }
  });

  return leafKeys;
};

const isLikelyFeaturePermissionKey = (key: string) =>
  /^[A-Z0-9_]+\.[A-Za-z0-9_]+$/.test(key);

export const sanitizeGroupFeaturePermissions = (
  checkedKeys: AntdCheckedKeys,
  featureTree: PermissionTreeNode[] = [],
) => {
  const selectedKeys = normalizeCheckedKeys(checkedKeys);
  const validPermissionKeys = collectLeafPermissionKeys(featureTree);
  const seen = new Set<string>();

  return selectedKeys.filter((key) => {
    const isValid = validPermissionKeys.size
      ? validPermissionKeys.has(key)
      : isLikelyFeaturePermissionKey(key);

    if (!isValid || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};
